import { useState, useEffect, useCallback, useRef } from 'react'

interface UseWakeLockResult {
	isWakeLockActive: boolean
	requestWakeLock: () => Promise<void>
	releaseWakeLock: () => void
}

export function useWakeLock(): UseWakeLockResult {
	const wakeLockRef = useRef<WakeLockSentinel | null>(null)
	const [isWakeLockActive, setIsWakeLockActive] = useState(false)

	const requestWakeLock = useCallback(async () => {
		if ('wakeLock' in navigator) {
			try {
				const lock = await navigator.wakeLock.request('screen')
				wakeLockRef.current = lock
				setIsWakeLockActive(true)
			} catch (err) {
				console.error(
					`${err instanceof Error ? err.name : 'Error'}, ${err instanceof Error ? err.message : 'Unknown error'}`,
				)
			}
		}
	}, [])

	const releaseWakeLock = useCallback(() => {
		if (wakeLockRef.current) {
			wakeLockRef.current
				.release()
				.then(() => {
					wakeLockRef.current = null
					setIsWakeLockActive(false)
				})
				.catch(err =>
					console.error(
						`${err instanceof Error ? err.name : 'Error'}, ${err instanceof Error ? err.message : 'Unknown error'}`,
					),
				)
		}
	}, [])

	useEffect(() => {
		return () => {
			releaseWakeLock()
		}
	}, [releaseWakeLock])

	return { isWakeLockActive, requestWakeLock, releaseWakeLock }
}
